import React from 'react';
import styles from './MainTop.module.css';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Typewriter from 'typewriter-effect';
import MainImage, { MainImageBackground } from './MainImage';

const MainTop = (props) => {

    return (
        <Container maxWidth="lg" className={styles.mainContainer} style={{...props.sx}}>
            <Typography className={styles.typingAni} variant="h3" element="h1">
                D<span style={{fontSize: '2rem'}}>ream </span> 
                I<span style={{fontSize: '2rem'}}>ndustrial </span> 
                S<span style={{fontSize: '2rem'}}>afety </span> 
                C<span style={{fontSize: '2rem'}}>enter</span>
                {/* 타이핑 참조 https://www.npmjs.com/package/typewriter-effect */}
                <Typewriter
                    onInit={(typewriter) => {
                        typewriter
                        // .typeString(`D<span style="font-size: 2rem;">ream </span>`)
                        // .typeString(`I<span style="font-size: 2rem;">ndustrial </span>`)
                        // .typeString(`S<span style="font-size: 2rem;">afety </span>`)
                        // .typeString(`C<span style="font-size: 2rem;">enter</span>`)
                        .typeString(`<span style="color:rgb(2 54 146)">안전관리대행</span>`)
                        .pauseFor(2000)
                        .deleteChars(2)
                        .typeString(`<strong style="color: rgb(2 54 146)">지도</strong>`)
                        .pauseFor(2000)
                        .deleteChars(6)
                        .typeString(`<strong style="color: rgb(2 54 146)">위험성평가</strong>`)
                        .pauseFor(2000)
                        .start();
                    }}
                    options ={{
                        // delay: 1,
                        loop: true,
                        deleteSpeed: 15
                    }}
                />
            </Typography>
            <div className={styles.mainimage}>
                {/* <MainImage/> */}
                {/* <MainImageBackground /> */}
            </div>
        </Container>
    )
}

export default MainTop;